import src from "IMAGE";
export default { src, width: 500, height: 79, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AJOTk4t8fHx1jIyMg42NjYB6enpyeHh4cYSEhHxhXmFdEAkPutjexVAAAAAASUVORK5CYII="};
